/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
export var AccountType = {
  ACCOUNT_TYPE_UNSPECIFIED: 0,
  SELLER: 1,
  EMPLOYEE: 2,
  KOL: 3,
  MCN: 4,
  OPERATOR: 5
};
export var AccountApplyStatus = {
  UNSPECIFIED: 0,
  REVIEWING: 1,
  REJECT: 2,
  PASSED: 3
};
export var AccountExtraKey = {
  AccountExtraKey_UNSPECIFIED: 0,
  SHOP_LIST_FIRST_SHOW: 1,
  CREATOR_AGREEMENT_FIRST_SHOW: 2,
  CONTACT_INFO_HAS_SET: 3,
  SHOWCASE_LIST_FIRST_SHOW: 4,
  CREATOR_EXAMPLE_FIRST_SHOW: 5
};
export var AccountPermission = {
  ACCOUNT_PERMISSION_UNSPECIFIED: 0,
  SET_0_COMMISSION_RATE: 1
};
export var SellerAccountStatus = {
  NEW_CREATE: 0,
  PENDING_TO_REVIEW: 1,
  ACTIVE: 2,
  DEACTIVE: 3,
  REVIEW_REJECTED: 4,
  IN_ACTIVE: 5,
  WITHDRAW: 6,
  PLATFORM_DISMISS: 7,
  CLOSING: 8
};
export var IdentityVerifyType = {
  VERIFY_UNKNOWN: 0,
  VERIFY_HasCommit: 1,
  VERIFY_Pure: 2,
  VERIFY_WithTax: 3,
  VERIFY_WithKYC: 4,
  VERIFY_WithKYC_Tax: 5,
  VERIFY_WithTax_SubSection: 6,
  VERIFY_EU: 7
};
export var AuditStatus = {
  AUDIT_UNKNOWN: 0,
  AUDIT_PASS: 1,
  AUDIT_UNDER_REVIEW: 2,
  AUDIT_NEED_REVIEW: 3,
  AUDIT_REVIEW_FAILED: 4,
  AUDIT_REJECT: 5,
  StageOneUnderReview: 11,
  StageOneNeedUpdate: 12,
  StageOneNeedSupplement: 13,
  StageOneVerified: 14,
  StageTwoUnderReview: 30,
  StageTwoNeedUpdate: 31,
  StageTwoVerifed: 32,
  StageFullReject: 50
};
export var USKYCStatus = {
  KYCNotSubmitted: 1,
  KYCUnderReview: 2,
  KYCFailed: 3,
  KYCRejected: 4,
  KYCTimedOut: 5,
  KYCNotNeedOrPassed: 6
};
export var ExternalType = {
  Shopee: 1
};
export var OperateType = {
  Bind: 1,
  Update: 2
};
export var VerifyResult = {
  Valid: 1,
  Invalid: 2,
  Error: 3
};